import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';
import Typography from '../../../Typography';
import CreditCardIcon from '../../../icons/CreditCardIcon';
import BarCodeIcon from '../../../icons/BarCodeIcon';

function PaymentFormInput({ intl, classes }) {
  return (
    <div className={classes.root}>
      <label className={classes.label}>
        <Field
          component="input"
          type="radio"
          name="paymentForm"
          value="creditCard"
          className={classes.radio}
        />
        <Typography className={classes.button} type="caption">
          <CreditCardIcon className={classes.icon} alt={intl.formatMessage({ id: 'creditCard' })} />
          <FormattedMessage id="creditCard" />
        </Typography>
      </label>
      <label className={classes.label}>
        <Field
          component="input"
          type="radio"
          name="paymentForm"
          value="bankSlip"
          className={classes.radio}
        />
        <Typography className={classes.button} type="caption">
          <BarCodeIcon className={classes.icon} alt={intl.formatMessage({ id: 'bankSlip' })} />
          <FormattedMessage id="bankSlip" />
        </Typography>
      </label>
    </div>
  );
}

PaymentFormInput.propTypes = {
  intl: intlShape.isRequired,
  classes: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    marginBottom: theme.spacing.medium,
  },
  label: {
    position: 'relative',
    '&:not(:first-child)': {
      marginLeft: theme.spacing.small,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  radio: {
    position: 'absolute',
    opacity: 0,
  },
  button: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 210,
    border: [[1, 'solid', theme.palette.common.minBlack]],
    borderRadius: 2,
    padding: [[theme.spacing.medium, theme.spacing.small]],
    '$radio:checked + &': {
      backgroundColor: theme.palette.success[500],
      borderColor: theme.palette.success[500],
      color: theme.palette.common.white,
    },
    [theme.breakpoints.down('md')]: {
      width: 196,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  icon: {
    marginRight: theme.spacing.xsmall,
    flex: '0 0 auto',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
});

export default compose(
  injectIntl,
  injectSheet(stylesheet),
)(PaymentFormInput);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/OrderPaymentForm/PaymentFormInput/PaymentFormInput.js